import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@headlessui/react";

export default function RatiosReportDialog({ open, onClose, deviceId, deviceType, API_BASE }) {
  const { t } = useTranslation();
  const [period, setPeriod] = useState("daily");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [format, setFormat] = useState("xlsx");

  const handleDownload = async () => {
    if (!start || !end || new Date(start) > new Date(end)) {
      alert(t("reports.dateError"));
      return;
    }

    const lang = localStorage.getItem("i18nextLng") || "tr";
    const url = `${API_BASE}/reports/export-ratios?deviceId=${deviceId}&deviceType=${deviceType}&period=${period}&start=${start}&end=${end}&format=${format}&lang=${lang}`;
    window.open(url, "_blank");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg">
          <Dialog.Title className="text-lg font-semibold text-gray-800 mb-4">
            {t("ratios.reportTitle")}
          </Dialog.Title>

          <div className="flex flex-col gap-3">
            <div>
              <label className="block text-sm text-gray-600 mb-1">{t("ratios.period")}</label>
              <select
                value={period}
                onChange={(e) => setPeriod(e.target.value)}
                className="w-full border rounded-md px-3 py-2 text-sm"
              >
                <option value="daily">{t("ratios.rangeDaily")}</option>
                <option value="weekly">{t("ratios.rangeWeekly")}</option>
                <option value="monthly">{t("ratios.rangeMonthly")}</option>
              </select>
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">{t("reports.startDate")}</label>
              <input
                type="date"
                value={start}
                onChange={(e) => setStart(e.target.value)}
                className="w-full border rounded-md px-3 py-2 text-sm"
              />
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">{t("reports.endDate")}</label>
              <input
                type="date"
                value={end}
                onChange={(e) => setEnd(e.target.value)}
                className="w-full border rounded-md px-3 py-2 text-sm"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-600 mb-1">{t("reports.format")}</label>
              <select
                value={format}
                onChange={(e) => setFormat(e.target.value)}
                className="w-full border rounded-md px-3 py-2 text-sm"
              >
                <option value="csv">CSV</option>
                <option value="xlsx">{t("reports.excel")}</option>
                <option value="png">{t("reports.chart")} (PNG)</option>
              </select>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-md text-gray-700 hover:bg-gray-100 text-sm"
            >
              {t("common.cancel")}
            </button>
            <button
              onClick={handleDownload}
              className="px-4 py-2 rounded-md bg-sky-600 text-white hover:bg-sky-700 text-sm"
            >
              {t("common.download")}
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
